// Dni ustawowo wolne od pracy w Polsce — mapa "YYYY-MM-DD" -> nazwa święta.
// Lustrzana logika istnieje w backendzie (hr.service.ts) do liczenia dni z puli.

function easterSunday(year) {
  // Algorytm Gaussa/Meeusa (kalendarz gregoriański).
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(year, month - 1, day));
}

const cache = {};

export function polishHolidays(year) {
  if (cache[year]) return cache[year];
  const iso = (d) => d.toISOString().slice(0, 10);
  const plus = (d, days) => {
    const r = new Date(d);
    r.setUTCDate(r.getUTCDate() + days);
    return r;
  };
  const easter = easterSunday(year);
  const map = {
    [`${year}-01-01`]: 'Nowy Rok',
    [`${year}-01-06`]: 'Trzech Króli',
    [`${year}-05-01`]: 'Święto Pracy',
    [`${year}-05-03`]: 'Konstytucja 3 Maja',
    [`${year}-08-15`]: 'Wniebowzięcie NMP',
    [`${year}-11-01`]: 'Wszystkich Świętych',
    [`${year}-11-11`]: 'Święto Niepodległości',
    [`${year}-12-25`]: 'Boże Narodzenie',
    [`${year}-12-26`]: 'Drugi dzień świąt',
  };
  // Wigilia jest dniem wolnym od 2025 r.
  if (year >= 2025) map[`${year}-12-24`] = 'Wigilia';
  map[iso(easter)] = 'Wielkanoc';
  map[iso(plus(easter, 1))] = 'Poniedziałek wielkanocny';
  map[iso(plus(easter, 49))] = 'Zielone Świątki';
  map[iso(plus(easter, 60))] = 'Boże Ciało';
  cache[year] = map;
  return map;
}
